import { AxiosResponse } from 'axios';
import client from 'api/client';
import { AgentRoles } from 'api/models/payload/AgentRoles';
import { Agent } from 'types';

export function get(kindOfAgent: AgentRoles): Promise<AxiosResponse<Agent[]>> {
    const url = `/agents/${kindOfAgent}`;
    return client.get<Agent[]>(url);
}

export function assignAgent(
    role: AgentRoles,
    data: {
        application_id: number;
        agent_id: number;
    }
): Promise<AxiosResponse> {
    return client.put(`/assign-agent/${role}`, data);
}
